import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/core/services/loader.service';
import { fadeAnimations } from '../../animations/fading.animation';

@Component({
  selector: 'atram-loader',
  templateUrl: './atram-loader.component.html',
  styleUrls: ['./atram-loader.component.less'],
  animations: [fadeAnimations.default, fadeAnimations.down]
})
export class AtramLoaderComponent implements OnInit {

  @Input() isBGBlack: boolean = false;
  @Input() imageSource: string = '';
  @Input() spSiteFolterPath: string = '';

  public activeLoader: Subject<boolean>;
  public isActive: Boolean = false;
  
  constructor(loaderService: LoaderService) {
    this.activeLoader = loaderService.activeLoader;
    // if(this.activeLoader){
    //   public isAc
    // }
  }

  ngOnInit() {
  }


}
